import './index.less';

export default {
  template: `
    <div class="select-wrap btn-group">
      <button type="button" class="btn btn-default dropdown-toggle" 
          data-toggle="dropdown">
        {{currentText}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu" role="menu">
        <li v-for="item in source" v-on:click="select(item.value)">
          {{item.text}}
        </li>
      </ul>
    </div>
  `,
  props:['source','value'],
  methods:{
    select:function(value){
      // 通过 input 事件带出数值
      this.$emit('input', value);
    }
  },
  computed:{
    currentText:function(){
      if(!Array.isArray(this.source)) return;
      return this.source.filter(item=>item.value==this.value)[0].text;
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/select/index.js